const utils = require('../../lib/utils');

module.exports = {
	config: {
		environmentDependent: true
	},

	model: {
		headline: '',
		content: '',
		image: {}
	},

	methods: {
		/**
		 * this function has to return true if the environment dependent refresh should be performed.
		 *
		 * @param   activeEnvironment               {} - active environment
		 * @param   newEnvironment                  {} - new environment
		 * @param   serverKnownEnvironment          {} - environment known by the server
		 * @param   initialExecution                boolean - is this the initial execution
		 * @param   externalDrivenCall              boolean - e.g., browser resize -> true, ibt-grid-style-change -> false
		 * @param   environmentUpdateByParent       boolean - has a parent of mine decided to refresh and already updated by own activeEnvironment
		 * @returns boolean
		 */
		environmentRefreshNecessary: function(activeEnvironment, newEnvironment, serverKnownEnvironment, initialExecution, externalDrivenCall, environmentUpdateByParent){
			// check if loading options are in charge
			if(initialExecution && ((this.model._image || {}).config || {}).loadingOptions) return true;

			// check if multiple images are available
			var multipleImagesFound = false;
			utils.forEach(this.model.image, function(image){
				if(image.rendered && image.rendered.length > 1){
					multipleImagesFound = true;
					return false;
				}
			});
			if(!multipleImagesFound) return false;

			// check if environment has changed enough
			// breakPoint has been changed to a bigger one
			if(activeEnvironment.breakPoint != newEnvironment.breakPoint && activeEnvironment.breakPointSize < newEnvironment.breakPointSize) return true;

			// fallback
			return false;
		}
	},

	hooks: {
		attach: function($element, options){
			if(options.environmentChanged) {
				console.log('dummy env changed', new Date().getTime(), options.environment);
			}
			else {
				console.log('dummy init');
			}
		}
	}

	// handlers: [
	// 	{
	// 		name: 'DOMReady',
	// 		handle: function(callerComponent){
	// 			this.refresh();
	// 		}
	// 	}
	// ]
};